export interface ChatQueryBody {
  message: string;
  similarity_top_k: number;
  session_id: string;
  model_name: string | ModelType;
  search_mode: string;
  chat_mode: string;
  streaming: boolean;
  evaluate: boolean;
  chat_history: ChatHistoryRequest[];
  fast: boolean;
  temperature: number;
  expert_mode: boolean;
  source?: Source | string;
}

export enum Source {
  ALL = 'all',
  SIGNATURE_PLATFORM_WIKI = 'signatureplatform-wiki',
  SMARTID = 'smartid',
  SMARTID_WEB = 'smartid-web',
  SMARTID_PDF = 'smartid-pdf',
  SMARTID_CONFLUENCE = 'smartid-confluence',
  JIRA_SKIS = 'jira-skis'
}

export interface SourceOption {
  value: Source;
  labelKey: string;
}

export const SOURCE_OPTIONS: SourceOption[] = [
  { value: Source.ALL, labelKey: 'source.all' },
  { value: Source.SIGNATURE_PLATFORM_WIKI, labelKey: 'source.signaturePlatformWiki' },
  { value: Source.SMARTID, labelKey: 'source.smartid' },
  { value: Source.SMARTID_WEB, labelKey: 'source.smartidWeb' },
  { value: Source.SMARTID_PDF, labelKey: 'source.smartidPdf' },
  { value: Source.SMARTID_CONFLUENCE, labelKey: 'source.smartidConfluence' },
  { value: Source.JIRA_SKIS, labelKey: 'source.jiraSkis' }
];

export enum Role {
  USER = 'user',
  ASSISTANT = 'assistant'
}

export interface ChatHistory {
  user: string;
  bot: string | undefined;
}

export interface ChatHistoryRequest {
  content: string;
  role: Role;
}

export interface ChatQuerySettings {
  index_name: string;
  similarity_top_k: number;
  model: string | ModelType;
  search_mode: string;
  chat_mode: string;
  streaming: boolean;
  evaluate: boolean;
  fast: boolean;
  temperature: number;
  expert_mode: boolean;
  source?: Source | string;
}

export enum ModelType {
  GPT_4_1_MINI = 'gpt-4.1-mini',
  GPT_4_1 = 'gpt-4.1',
}

export enum SearchMode {
  HYBRID = 'hybrid',
  TEXT = 'text',
  SEMANTIC = 'semantic'
}

export enum ClientName {
  SK = 'SK ID Solutions',
}

export enum ChatMode {
  OPENAI = 'openai',
  CONDENSE_PLUS_CONTEXT = 'condense_plus_context',
}
